exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img[data-v-90cac2f4]{border:2px solid #fff}.img img[data-v-90cac2f4]{display:block;cursor:pointer}.img.curr[data-v-90cac2f4]{border:2px solid #347FF4}.img[data-v-90cac2f4]{position:relative}.choose-input[data-v-90cac2f4]{position:absolute;left:-99999px}\n", ""]);

// exports
